import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { faCircleCheck, faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { faCirclePause, faCircleRight } from "@fortawesome/free-regular-svg-icons";
import { formatDateString } from "../utils";

const ListWrapper = styled.ul`
  padding: 0;
  list-style: none;
  margin: 4px 0;
  line-height: 150%;
  text-align: left;
  svg {
    margin-right: 4px;
  }
`;

const DueDateBox = styled.span`
  display: inline-block;
  padding: 4px 6px 2px 6px;
  background-color: ${(props) => (props.oldValue ? "#D9D9D9" : "rgba(128, 186, 76, 0.4)")};
  border-radius: 4px;
  margin-right: 4px;
  margin-bottom: 4px;
`;

const StudyStatusItem = ({ item, icon, color, oldValue }) => {
  const { dl, descr, status } = item;
  const statusOptions = {
    1: { icon: faCircleRight, color: "#1f6feb" },
    2: { icon: faCirclePause, color: "#f5564a" },
    3: { icon: faCircleCheck, color: "#2ea043" },
  };

  return (
    <ListWrapper>
      <FontAwesomeIcon
        icon={icon ?? statusOptions[status].icon}
        style={{ color: color ?? statusOptions[status].color, fontSize: "16px", marginRight: "8px" }}
      />
      {item.dl && (
        <DueDateBox oldValue={oldValue}>
          <FontAwesomeIcon icon={faStopwatch} />
          {formatDateString(dl)}
        </DueDateBox>
      )}
      <span style={{ display: "inline-block" }}>{descr}</span>
    </ListWrapper>
  );
};

export default StudyStatusItem;
